import { axiosWL } from '../axiosManager.js'

//const guildId = process.env.guildId // 
const guildId = 564561

export default{
    getGuild() {
        let body = {
            query : `query { guildData{ guild(id:${guildId}) { members{ data{ id name guildRank } } } } }`
        }
        return axiosWL.post('/', body)
        .then(response => {
            return response.data
        })
    }
}